import React, {useState, useEffect} from 'react';

const SoundCloudEmbed = ({url}) => {
  const [embed, setEmbed] = useState(null);
  // Use oEmbed standard to get SoundCloud player
  useEffect(() => {
    const fetchPlayer = async () => {
      const response = await fetch(`https://soundcloud.com/oembed?format=json&maxheight=166&url=${url}`);
      setEmbed(await response.json());
    };

    fetchPlayer();
  }, [url]);

  return url ? (
    <div
      dangerouslySetInnerHTML={embed ? {__html: embed.html} : null}
      className="w-full max-w-3xl mx-auto mt-4 mb-6"
      style={{height: '166px'}}
    />
  ) : null;
};

export default SoundCloudEmbed;
